<div class="bg-white px-6 py-5 text-blue-950">
  <div class="flex items-center pb-4">
    <h2
      class="m-0 inline-flex items-center gap-2 font-montserrat text-base font-bold uppercase"
    >
      <span
        class="material-icons-outlined h-[20px] w-[20px] shrink-0 text-[20px] leading-[20px]"
        aria-hidden="true"
        >show_chart</span
      >
      {{ data$()?.title }}
    </h2>
  </div>
  <div
    class="relative box-border flex min-h-[310px] items-center justify-center pt-1.5 text-center text-xl font-normal"
    [attr.aria-busy]="loading"
  >
    <div
      class="h-[304px] w-full"
      [ngClass]="{ 'opacity-20 blur-[0.1rem]': loading }"
    >
      <canvas
        baseChart
        role="img"
        [attr.aria-label]="'Line chart: ' + data$()?.title"
        [type]="chartService$.lineChartType"
        [data]="chartService$.lineChartData$()"
        [options]="chartService$.lineChartOptions"
        [plugins]="chartService$.lineChartPlugins"
        (chartClick)="chartService$.chartClicked($event)"
      ></canvas>
    </div>
    @if (loading) {
      <div class="absolute" role="status" aria-label="Loading chart">
        <mat-spinner [diameter]="75" aria-hidden="true"></mat-spinner>
      </div>
    }
  </div>

  <div
    class="flex items-center gap-2.5 px-2 pb-0.5 pt-3 font-lato font-normal"
    aria-label="Ticket history legend"
  >
    <span
      class="bg-purple h-3 w-3 shrink-0 rounded-full"
      aria-hidden="true"
    ></span>
    Ticket count
  </div>
</div>
